import $ from 'jquery';
import 'bootstrap/js/dist/modal';
import { AgeVerificationAgeMismatchModal } from './age-verification-age-mismatch-modal';
import { AgeVerificationNameMismatchModal } from './age-verification-name-mismatch-modal';
import GaTracking from '../../../core/components/ga-tracking';
import { DokobitError } from '../../../types/dokobit-errors';
const ELEMENT_SELECTOR = '.js__age-verification-dokobit';
const ERROR_ELEMENT_SELECTOR = '.js__age-verification-error';
export class AgeVerificationDokobit {
    static $element;
    static $countryAlert;
    static locale;
    static datalayerEventAction;
    static datalayerCategory;
    static $errorElement;
    static init() {
        this.$element = $(ELEMENT_SELECTOR);
        this.$countryAlert = $(`${ELEMENT_SELECTOR}-country-alert`);
        this.locale = this.$element.data('locale');
        this.datalayerEventAction = this.$element.data('datalayer-event-action') || 'Verification Identity';
        this.datalayerCategory = this.$element.data('datalayer-category') || 'Dokobit';
        this.$errorElement = $(ERROR_ELEMENT_SELECTOR);
        if (!this.$element.length) {
            return;
        }
        if (this.$errorElement.length) {
            const errorKey = this.$errorElement.data('error-key');
            const additionalData = this.$errorElement.data('additional-data');
            this.handleErrors(errorKey, additionalData);
        }
    }
    static handleErrors(error, additionalData) {
        GaTracking.pushDataLayer({
            event: 'gtmZoneEvent',
            eventAction: this.datalayerEventAction,
            eventCategory: this.datalayerCategory,
            eventLabel: error,
        });
        if (error === DokobitError.AgeMismatch) {
            AgeVerificationAgeMismatchModal.init();
            AgeVerificationAgeMismatchModal.show();
            return;
        }
        if (error === DokobitError.NameMismatch) {
            AgeVerificationNameMismatchModal.init();
            AgeVerificationNameMismatchModal.updateDescription(additionalData.entered_data, additionalData.verified_data);
            AgeVerificationNameMismatchModal.show();
            return;
        }
        if (error === DokobitError.CountryNotSupported) {
            this.$countryAlert.show();
            return;
        }
    }
}
